var Base = require('_js/base'),
  ko = require('knockout'),
  APIHelper = require('_js/APIHelper');

var ExternalCourse = function(params) {
  this.params = params;
  // this.$container = params.container;
  this.$el = $(params.el);
  this.id = this.$el.data('history-course-id');
  this.api = this.$el.data('remove-api');
  this.$container = this.$el.parentsUntil('.courses-container.history');
};

ExternalCourse.prototype.removeCourse = function() {
  var self = this;
  APIHelper.delete(this.api + '/' + this.id, undefined, function() {
    self.$container.slideUp();
  });
};

var model = function(params) {
  this.params = params;
};

function CoursesList() {
  this.init();
}

CoursesList.prototype = new Base();

CoursesList.prototype.init = function() {
  var $externalCourse = $('[data-external-course]');
  if ($externalCourse.get(0) !== undefined) {
    $externalCourse.each(function(i, course) {
      ko.applyBindings(
        new model({ element: $(course).data('external-course') }),
        $(course).get(0)
      );
    });
  }
};

module.exports = CoursesList;
